import * as _ from 'lodash';
import * as moment from 'moment-timezone';

export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
    return value !== undefined && value !== null ? `${value}` : '';
}

export function getValueInRange(value: number, max: number, min = 0): number {
    return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
    return typeof value === 'string';
}

export function isNumber(value: any): value is number {
    return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
    return value !== undefined && value !== null;
}

export function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

export function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function hasClassName(element: any, className: string): boolean {
    return (
        element &&
        element.className &&
        element.className.split &&
        element.className.split(/\s+/).indexOf(className) >= 0
    );
}

export function closest(element: HTMLElement, selector): HTMLElement {
    if (!selector) {
        return null;
    }

    return element.closest(selector);
}

export function debounce(delay = 300): MethodDecorator {
    // tslint:disable-next-line: no-any
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        let timeout = null;

        const original = descriptor.value;

        descriptor.value = function (...args) {
            // tslint:disable-next-line: no-unsafe-any
            clearTimeout(timeout);
            // tslint:disable-next-line: no-unsafe-any
            timeout = setTimeout(() => original.apply(this, args), delay);
        };

        return descriptor;
    };
}

export function pruneEmpty(obj) {
    return function prune(current) {
        _.forOwn(current, function (value, key) {
            if (_.isUndefined(value) || _.isNull(value) ||
                (_.isObject(value) && _.isEmpty(prune(value)))) {
                delete current[key];
            }
        });
        if (_.isArray(current)) {
            _.pull(current, undefined);
        }
        return current;
    }(_.cloneDeep(obj));
}

export function getDateAfterNDays(days: number, marketTimeZone?: string): Date {
    let m = marketTimeZone ? moment().tz(marketTimeZone, true) : moment();
    let date = m.endOf("day").toDate()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    return date;
}